import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "adobe-experience-platform-edge-network---tutorials"
    }}>{`Adobe Experience Platform Edge Network - Tutorials`}</h1>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./send-overrides-sendevent.md"
        }}>{`Sending configuration overrides using sendEvent`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./send-overrides-rules.md"
        }}>{`Sending configuration overrides using Rules`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      